import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "../components";
import {
  Home,
  LoginPage,
  SignUpPage,
  ForgotPasswordPage,
  ChangePasswordPage,
  // CodeVerificationPage,
  SignupVerificationPage,
  CustomerTypePage,
  BusinessCustomerPage,
  PaymentMethodPage,
  PendingApprovalPage,
  PasswordSuccessfullPage,
  // Delivery pages
  DeliveryHomePage,
  DeliveryTypePage,
  DeliveryStepsPage,
  PriceQuotationPage,
  QuoteApprovedPage,
  QuotLocationPage,
  ProfileMainPage,
  ProfileApprovedPage,
  ProEditCardPage,
  // Routes Step Page
  RoutesStepsPage,
  // Transaction
  TransactionMainPage,
  TransactionDetailsPage,
  // order
  MyOrdersPage,
  OrderDetailsPage,
  OrderLabelPage,
  // message page
  MessagePage,
  // admin section
  AdminLoginPage,
  ChatPage,
  // Dispatches
  DispatcheMainPage,
  DispatchesDetailsPage,

  // admin custoimer
  CustomerMainPage,
  CustomerDetailsPage,
  // Drivers
  DriversMainPage,
  PersonalDetailsPage,
  // Job History
  JobHistoryMainPage,

  // Accounting
  AccountingMainPage,
  // Agents
  AgentsMainPage,
  NotFound,
  WalletCreatedPage,
  LinkExpiredPage,
  Forbidden,
} from "../pages";
import { useSelector } from "react-redux";
import {
  PublicRoute,
  ProtectedRoute,
  AdminRoute,
  AdminPublicRoute,
} from "./ProtectedRoute";

const AppRoutes = () => {
  const {
    user: useInfo = {},
    isAuthenticated = false,
    redirto = "",
  } = useSelector((state) => state.auth);

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/login"
            element={
              <PublicRoute isAuthenticated={isAuthenticated}>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route
            path="/signup"
            element={
              <PublicRoute isAuthenticated={isAuthenticated}>
                <SignUpPage />
              </PublicRoute>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <PublicRoute isAuthenticated={isAuthenticated}>
                <ForgotPasswordPage />
              </PublicRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <PublicRoute isAuthenticated={isAuthenticated}>
                <ChangePasswordPage />
              </PublicRoute>
            }
          />
          {/* <Route path="/verification-code" element={<CodeVerificationPage />} /> */}
          <Route
            path="/verification"
            element={
              // <PublicRoute isAuthenticated={isAuthenticated}>
              <SignupVerificationPage />
              // </PublicRoute>
            }
          />
          <Route
            path="/customer-type"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                // useInfo={useInfo}
              >
                <CustomerTypePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile-approved"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}

                // redirto={redirto}
                // useInfo={useInfo}
              >
                <ProfileApprovedPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/business-customer"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}

                // redirto={redirto}
                // useInfo={useInfo}
              >
                <BusinessCustomerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment-method"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}

                // redirto={redirto}
                // useInfo={useInfo}
              >
                <PaymentMethodPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pending-appproval"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                // useInfo={useInfo}
              >
                <PendingApprovalPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/password-success"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <PasswordSuccessfullPage />
              </ProtectedRoute>
            }
          />
          {/* Delivery pages */}
          <Route
            path="/delivery-home"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <DeliveryHomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/delivery-type"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <DeliveryTypePage />
              </ProtectedRoute>
            }
          />
          {/* Routes Steps Page */}
          <Route
            path="/route-steps"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <RoutesStepsPage />
              </ProtectedRoute>
            }
          />
          {/* Delivery Steps */}
          <Route
            path="/delivery-steps"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <DeliveryStepsPage />
              </ProtectedRoute>
            }
          />
          {/* Delivery Quote Approved pages */}
          <Route
            path="/price-quotation"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <PriceQuotationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quote-approved"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <QuoteApprovedPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quote-location"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <QuotLocationPage />
              </ProtectedRoute>
            }
          />
          {/* profile section */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <ProfileMainPage />
              </ProtectedRoute>
            }
          />
          <Route path="/profile-edit-card" element={<ProEditCardPage />} />
          {/* transaction pages */}
          <Route
            path="/transaction"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <TransactionMainPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transaction-details"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <TransactionDetailsPage />
              </ProtectedRoute>
            }
          />
          {/* order pages */}
          <Route
            path="/my-orders"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <MyOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order-details"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <OrderDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order-label"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <OrderLabelPage />
              </ProtectedRoute>
            }
          />
          {/* message page  */}
          <Route
            path="/message"
            element={
              <ProtectedRoute
                isAuthenticated={isAuthenticated}
                redirto={redirto}
                useInfo={useInfo}
              >
                <MessagePage />
              </ProtectedRoute>
            }
          />
          {/* admin section */}

          <Route
            path="/admin/login"
            element={
              <AdminPublicRoute useInfo={useInfo}>
                <AdminLoginPage />
              </AdminPublicRoute>
            }
          />
          <Route
            path="/admin/chat"
            element={
              <AdminRoute>
                <ChatPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/dispatches"
            element={
              <AdminRoute>
                <DispatcheMainPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/dispatche-details/:id"
            element={
              <AdminRoute>
                <DispatchesDetailsPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/customers"
            element={
              <AdminRoute>
                <CustomerMainPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/customer-details/:id"
            element={
              <AdminRoute>
                <CustomerDetailsPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/drivers"
            element={
              <AdminRoute>
                <DriversMainPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/drivers/personal-details/:id"
            element={
              <AdminRoute>
                <PersonalDetailsPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/job-history"
            element={
              <AdminRoute>
                <JobHistoryMainPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/accounting"
            element={
              <AdminRoute>
                <AccountingMainPage />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/agents"
            element={
              <AdminRoute>
                <AgentsMainPage />
              </AdminRoute>
            }
          />

          <Route path="*" element={<NotFound />} />
          <Route path="/403" element={<Forbidden />} />
          {/* status pages */}

          <Route path="/wallet-created" element={<WalletCreatedPage />} />
          <Route path="/link-expired" element={<LinkExpiredPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default AppRoutes;
